<template>
  <div>
    <b-sidebar
      id="sidebar-stock-update"
      bg-variant="white"
      v-model="visibility"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
      width="600px"
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Add Goods Receiving Note</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibility = false"
        />
      </div>

      <b-form class="p-2" @submit.prevent>
        <b-row class="">
          <b-col md="12">
            <b-form-group
              label="Date"
              invalid-feedback="Date is required"
              ref="updDate"
            >
              <flat-pickr
                :config="config"
                v-model="grnObj.date"
                class="form-control"
                :placeholder="$t('Select Date')"
                @on-change="CheckUpdateDate()"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              label="Vendor"
              invalid-feedback="Vendor is required."
              ref="vID"
            >
              <v-select
                v-model="grnObj.vendorID"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="vendors"
                :reduce="(opt) => opt.id"
                label="name"
                :clearable="true"
                placeholder="Select vendor"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              label="Delivery Charges"
              invalid-feedback="Please enter valid amount"
              ref="delCharge"
            >
              <b-form-input
                type="number"
                v-model="grnObj.deliveryCharges"
                placeholder="Enter delivery charges"
                @input="CheckDelCharges()"
              >
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="Note" ref="updNote">
              <b-form-textarea
                v-model.trim="grnObj.narration"
                placeholder="Enter note"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-row v-for="(item, index) in poItems" :key="index">
              <b-col md="4" class="pr-md-0">
                <b-form-group
                  label="Product"
                  invalid-feedback="Product is required."
                >
                  <v-select
                    v-model="item.productID"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="products"
                    :reduce="(opt) => opt.id"
                    label="name"
                    :clearable="false"
                    placeholder="Select product"
                  />
                </b-form-group>
              </b-col>
              <b-col md="3" class="pr-md-0">
                <b-form-group label="Qty" invalid-feedback="Qty is required.">
                  <b-form-input
                    type="number"
                    v-model="item.finalQty"
                    placeholder="Enter quantity"
                    @input="setTotal(item)"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="3" class="pr-md-0">
                <b-form-group
                  label="Unit Price"
                  invalid-feedback="Unit Price is required."
                >
                  <b-form-input
                    type="number"
                    v-model="item.unitPrice"
                    placeholder="Enter amount"
                    @input="setTotal(item)"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="2" class="pr-md-0">
                <b-button
                  v-if="index == poItems.length - 1"
                  variant="outline-primary"
                  class="btn-icon rounded-circle mt-md-1 mr-25"
                  @click="addItem()"
                >
                  <feather-icon icon="PlusIcon" />
                </b-button>
                <b-button
                  variant="outline-danger"
                  class="btn-icon rounded-circle mt-md-1"
                  @click="removeItem(index)"
                >
                  <feather-icon icon="Trash2Icon" />
                </b-button>
              </b-col>
            </b-row>
            <div
              md="12"
              class="font-weight-bold border-top border-bottom py-25 mt-50"
            >
              Total: {{ poTotal }}
            </div>
          </b-col>
          <b-col md="12" class="mt-1">
            <b-button
              variant="success"
              block
              :disabled="saving"
              @click="updateStock(false)"
            >
              <b-spinner
                v-if="saving && !printLoading"
                small
                type="grow"
                class="mr-50"
              />
              <span>Update</span>
            </b-button>
          </b-col>
          <b-col md="12" class="mt-1">
            <b-button
              variant="warning"
              block
              :disabled="saving"
              @click="updateStock(true)"
            >
              <b-spinner
                v-if="saving && printLoading"
                small
                type="grow"
                class="mr-50"
              />
              <span>Update & Print</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-sidebar>

    <b-card title="Goods Receiving Note">
      <b-form-group v-if="false">
        <b-input-group>
          <b-input-group-prepend is-text>
            <feather-icon icon="SearchIcon" />
          </b-input-group-prepend>

          <b-form-input v-model="searchQuery" :placeholder="$t('Search') + '...'">
          </b-form-input>
        </b-input-group>
      </b-form-group>

      <b-row>
        <b-col md="3">
          <b-button @click="addOpen()" block variant="primary">
            <feather-icon icon="PlusIcon" class="mr-50" />
            <span class="align-middle">GRN</span>
          </b-button>
        </b-col>
      </b-row>

      <b-table
        class="mt-1"
        :items="items"
        :fields="fields"
        :busy="dataLoading"
        responsive
        show-empty
      >
        <template #table-busy>
          <div class="d-flex justify-content-center mb-3 mt-5">
            <b-spinner
              type="grow"
              variant="primary"
              label="Spinning"
            ></b-spinner>
          </div>
        </template>

        <template #cell(id)="data">
          <b-badge variant="light-primary">
            {{ data.item.grn.id }}
          </b-badge>
        </template>
        <template #cell(quotation)="data">
          <b-badge variant="light-primary">
            {{ data.item.grn.quotationID }}
          </b-badge>
        </template>
        <template #cell(date)="data">
          <b-badge variant="light-primary">
            {{
              new Date(data.item.grn.date).toLocaleDateString("en-UK", {
                year: "numeric",
                day: "numeric",
                month: "short",
              })
            }}
          </b-badge>
        </template>
        <template #cell(total)="data">
          <b-badge variant="light-primary">
            {{ data.item.grn.total }}
          </b-badge>
        </template>
        <template #cell(deliveryCharges)="data">
          <b-badge variant="light-primary">
            {{ data.item.grn.deliveryCharges }}
          </b-badge>
        </template>
        <template #cell(note)="data">
          {{ data.item.grn.narration }}
        </template>

        <template #cell(actions)="data">
          <b-button
            variant="primary"
            v-b-tooltip.hover.left
            title="Print"
            class="btn-icon"
            @click="printReport(data.item.grn)"
          >
            <feather-icon icon="PrinterIcon" />
          </b-button>
        </template>
      </b-table>

      <!-- <b-col cols="12" class="d-flex align-items-center justify-content-center">
        <b-pagination
          v-model="currentPage"
          :total-rows="items.length"
          :per-page="perPage"
          first-number
          last-number
          class="mb-0 mt-1 mt-sm-0"
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </b-col> -->
    </b-card>
  </div>
</template>
<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BBadge,
  BPagination,
  BImg,
  BFormCheckbox,
  BFormGroup,
  BForm,
  BSpinner,
  BSidebar,
  BInputGroupPrepend,
  BInputGroup,
  BFormTextarea,
  VBTooltip,
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BBadge,
    BPagination,
    BImg,
    BFormCheckbox,
    BFormGroup,
    BForm,
    BSpinner,
    BSidebar,
    BInputGroupPrepend,
    BInputGroup,
    BFormTextarea,
    vSelect,
    flatPickr,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      config: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d\\TH:i:S",
      },
      reportDomain: this.$store.state.report.replace(/_/g, ""),
      perPage: 30,
      currentPage: 1,
      dataLoading: false,
      items: [],
      fields: [
        { label: "ID", key: "id" },
        { label: "quotation ID", key: "quotation" },
        { label: "Date", key: "date" },
        { label: "Delivery Charges", key: "deliveryCharges" },
        { label: "Total", key: "total" },
        { label: "Note", key: "note" },
        { label: "actions", key: "actions" },
      ],
      searchQuery: "",
      vendors: [],
      products: [],
      grnObj: {
        quotationID: 0,
        date: null,
        deliveryCharges: 0,
        vendorID: 0,
        narration: "",
        createdBy: this.$store.state.userData.userID,
      },
      poItems: [],
      visibility: false,
      saving: false,
      printLoading: false,
    };
  },
  async created() {
    this.LoadData();
    this.LoadProduct();
    this.LoadSupplier();
  },
  computed: {
    filters: function () {
      return this.items.filter((item) => {
        return item.grn.id.toString().match(this.searchQuery.toLowerCase());
      });
    },
    poTotal() {
      return this.poItems.reduce((sum, el) => el.totalPrice + sum, 0);
    },
  },
  methods: {
    ...mapActions({ get: "get", post: "post", put: "put", delete: "delete" }),

    printReport(item) {
      const url =
        `https://${this.reportDomain}.myskool.app/Inventory/GRN?` +
        `dbb=${this.$store.state.userData.db}` +
        `&cID=${item.campusID}` +
        `&quotationID=${item.id}`;

      window.open(url, "_blank");
    },

    addOpen() {
      this.visibility = true;
      this.poItems = [];

      this.grnObj = {
        id: 0,
        quotationID: 0,
        date: null,
        vendorID: 0,
        deliveryCharges: 0,
        total: 0,
        journalEntryID: -1,
        narration: "",
        campusID: this.$store.state.userData.cId,
        createdBy: this.$store.state.userData.userID,
        updatedBy: 0,
        createdOn: null,
        updatedOn: null,
      };

      this.addItem();
    },
    addItem() {
      this.poItems.push({
        id: 0,
        grnID: 0,
        productID: 0,
        unitPrice: 0,
        requestedQty: 0,
        finalQty: 0,
        totalPrice: 0,
        campusID: this.$store.state.userData.cId,
      });
    },
    removeItem(index) {
      this.poItems.splice(index, 1);
    },
    setTotal(item) {
      let x = parseInt(item.finalQty);
      let y = parseInt(item.unitPrice);

      if (isNaN(x) || x <= 0 || isNaN(y) || y <= 0) {
        item.totalPrice = 0;
      } else {
        item.totalPrice = x * y;
        this.grnObj.total = this.poTotal;
      }
    },
    CheckUpdateDate() {
      var elem = this.$refs["updDate"];
      if (!this.grnObj.date) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckDelCharges() {
      var elem = this.$refs["delCharge"];
      let x = parseInt(this.grnObj.deliveryCharges);
      if (isNaN(x) || x < 0) {
        return (elem.state = false);
      } else {
        this.grnObj.deliveryCharges = x;
        return (elem.state = true);
      }
    },
    CheckPItems() {
      let state = true;
      this.poItems.forEach((item) => {
        let x = parseInt(item.finalQty);
        let y = parseInt(item.unitPrice);

        if (item.productID == 0 || isNaN(x) || x <= 0 || isNaN(y) || y <= 0) {
          state = false;
        } else {
          item.finalQty = x;
          item.requestedQty = x;
          item.unitPrice = y;
          item.totalPrice = x * y;
        }
      });
      return state;
    },
    async updateStock(isPrint) {
      const c1 = this.CheckUpdateDate();
      const c2 = this.CheckDelCharges();
      const c3 = this.CheckPItems();

      if (!c1) {
        this.$bvToast.toast("Please enter the date.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        return;
      }
      if (!c2) {
        this.$bvToast.toast("Please enter correct delivery charges.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        return;
      }
      if (!c3) {
        this.$bvToast.toast("Please enter the product details correctly.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        return;
      }

      this.saving = true;
      this.printLoading = isPrint;

      const pTotal = this.poItems.reduce(
        (acc, item) => acc + item.totalPrice,
        0
      );
      this.grnObj.total = pTotal + this.grnObj.deliveryCharges;
      this.grnObj.vendorID = !this.grnObj.vendorID ? 0 : this.grnObj.vendorID;
      const payload = { grn: this.grnObj, details: this.poItems };
      // console.log(payload);

      let obj = {
        url:
          this.$store.state.domain +
          "goodsReceivingNote/Save?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        body: payload,
        message: "GRN added successfully!",
        context: this,
        showAndReturn: true,
        token: this.$store.state.userData.token,
      };
      let res = await this.post(obj);
      if (res?.data) {
        this.visibility = false;
        this.LoadData();

        if (isPrint) {
          const url =
            `https://${this.reportDomain}.myskool.app/Inventory/GRN?` +
            `dbb=${this.$store.state.userData.db}` +
            `&cID=${this.$store.state.userData.cId}` +
            `&quotationID=${res.data.grn.id}`;

          window.open(url, "_blank");
        }
      }
      this.saving = false;
      this.printLoading = false;
    },

    async LoadProduct() {
      var obj = {
        url:
          this.$store.state.domain +
          "posStock?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.products = await this.get(obj);
      // console.log(this.products);
    },
    async LoadSupplier() {
      var obj = {
        url:
          this.$store.state.domain +
          "posSupplier?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.vendors = await this.get(obj);
    },
    async LoadData() {
      this.dataLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "goodsReceivingNote/LoadData?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.items = await this.get(obj);
      this.dataLoading = false;
    },
  },
};
</script>
<style></style>
